export default __webpack_public_path__ + "static/media/hearing-aura.faf2753e.svg";